import { render, staticRenderFns } from "./PropertyItem.vue?vue&type=template&id=f4aad0fa&scoped=true&"
import script from "./PropertyItem.vue?vue&type=script&lang=js&"
export * from "./PropertyItem.vue?vue&type=script&lang=js&"
import style0 from "./PropertyItem.vue?vue&type=style&index=0&id=f4aad0fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4aad0fa",
  null
  
)

export default component.exports